import Button from '@/common/components/base/button/Button';
import TimeSwipeWheel from '@/common/components/base/input/timeInput/timeSwipeWheel/TimeSwipWheel';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';

const TimePickerModal = ({
  open,
  onClose,
  onSubmit,
  initialValue,
  buttonText,
  modalLabel,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (val: string) => void;
  initialValue?: string;
  buttonText: string;
  modalLabel: string;
}) => {
  const initialParts = initialValue?.split(':') || [];
  const [hour, setHour] = useState(initialParts[0] || '00');
  const [minute, setMinute] = useState(initialParts[1] || '00');
  const hourValues = [...Array(24)].map((_, i) => String(i).padStart(2, '0'));
  const minuteValues = [...Array(60)].map((_, i) => String(i).padStart(2, '0'));

  const get24Hour = () => {
    let h = +hour;
    return String(h).padStart(2, '0');
  };

  const handleSubmit = () => {
    onSubmit(`${get24Hour()}:${minute}`);
    onClose();
  };

  const setNow = () => {
    const now = new Date();
    let h = now.getHours();
    const m = now.getMinutes();
    setHour(String(h).padStart(2, '0'));
    setMinute(String(m).padStart(2, '0'));
  };

  return (
    <MainModal open={open} closeModal={onClose}>
      <Box
        display="flex"
        flexDirection="column"
        gap="1"
        alignItems="center"
        p="4"
      >
        <TitleDescription mb={'20px'} width={'100%'}>
          {modalLabel}
        </TitleDescription>

        <Box
          display="flex"
          gap="6"
          alignItems="center"
          justifyContent="space-around"
          width={'100%'}
        >
          <TimeSwipeWheel
            values={minuteValues}
            value={minute}
            onChange={(val) => {
              setMinute(val);
            }}
            label="دقیقه"
            infinite={true}
            key={'minute'}
          />
          <Box
            style={{ fontSize: '20px', position: 'absolute', top: '12.5rem' }}
          >
            :
          </Box>
          <TimeSwipeWheel
            values={hourValues}
            value={hour}
            onChange={(val) => {
              setHour(val);
            }}
            label="ساعت"
            infinite={true}
            key={'hour'}
          />
        </Box>

        <Box
          display="flex"
          flexDirection={'column'}
          width={'100%'}
          gap="4"
          mt="4"
        >
          <Button onClick={setNow} variant="text">
            تنظیم به زمان فعلی
          </Button>
          <Button onClick={handleSubmit}> {buttonText}</Button>
        </Box>
      </Box>
    </MainModal>
  );
};

export default TimePickerModal;
